export const MAIN_SITE_URL = 'https://slamquest-staging.b12sites.com'
